// A tiny observable value with a hook, so a few bits of global state (the
// toast, a "data changed" tick) don't need a state library.
import { useEffect, useState } from 'preact/hooks';

export interface Signal<T> {
  get(): T;
  set(v: T): void;
  use(): T;
}

export function signal<T>(initial: T): Signal<T> {
  let value = initial;
  const subs = new Set<(v: T) => void>();
  return {
    get: () => value,
    set(v) {
      value = v;
      for (const s of subs) s(v);
    },
    use() {
      const [v, setV] = useState(value);
      useEffect(() => {
        subs.add(setV);
        setV(value);
        return () => void subs.delete(setV);
      }, []);
      return v;
    },
  };
}

/** Bumped after any write, so views showing derived numbers refetch. */
export const changed = signal(0);
export const bump = () => changed.set(changed.get() + 1);
